<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      :page.sync="page"
      @row-del="rowDel"
      @selection-change="selectionChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template
        slot="menuLeft"
        slot-scope="scope"
        v-if="isSelected != 'selected'"
      >
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="goDetail('add')"
          >上传素材
        </el-button>
        <el-input
          v-model="searchText"
          @keyup.native.enter="refreshChange"
          size="small"
          placeholder="请输入素材名称"
          type="text"
          style="width: 250px"
        >
          <el-button
            class="mar-0 pad-0"
            size="small"
            @click="refreshChange"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          class="none-border"
          icon="el-icon-view"
          @click="goDetail('view', scope.row)"
          >查看
        </el-button>
        <el-button
          type="text"
          size="small"
          class="none-border"
          icon="el-icon-edit"
          @click="goDetail('update', scope.row)"
          >修改
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          class="none-border"
          @click="rowDel(scope.row)"
          >删除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getMetaCommonList, delMetaCommon } from "@/api/busiMode/metaCommon";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      searchText: "",
      page: {
        size: 10,
        current: 1,
        total: 0,
      },
      loading: false,
      option: {
        height: "auto",
        calcHeight: 30,
        dialogWidth: 900,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        // selection: true,
        labelWidth: 120,
        menuWidth: 0,
        viewBtn: false,
        dialogClickModal: false,
        delBtn: false,
        editBtn: false,
        addBtn: false,
        cancelBtn: false,
        column: [
          {
            width: 150,
            overHidden: true,
            align: "left",
            label: "素材名称",
            prop: "name",
            hide: false,
          },
          {
            width: 120,
            overHidden: true,
            align: "left",
            label: "别名",
            prop: "alias",
            hide: false,
          },

          {
            width: 120,
            overHidden: true,
            align: "left",
            label: "素材类型",
            prop: "material_type",

            dicData: [
              {
                value: "picture",
                label: "图片",
              },
              {
                value: "flash",
                label: "Flash",
              },
              {
                value: "audio",
                label: "音频",
              },
              {
                value: "video",
                label: "视频",
              },
              {
                value: "document",
                label: "文本",
              },
              {
                value: "pdf",
                label: "PDF",
              },
              {
                value: "web",
                label: "网页",
              },
              {
                value: "doc-Word",
                label: "文档",
              },
              {
                value: "ppt",
                label: "PPT",
              },
              {
                value: "web",
                label: "网页",
              },
              {
                value: "realStream",
                label: "视频直播",
              },
              {
                value: "dataSource",
                label: "通用素材",
              },
              {
                value: "doc-Word",
                label: "文档",
              },
            ],
          },
          // {
          //   width: 220,
          //   overHidden: true,
          //   align: "left",
          //   label: "素材地址",
          //   prop: "file_url",
          //   hide: false,
          // },
          {
            width: 160,
            overHidden: true,
            align: "left",
            label: "信息类别",
            prop: "category_name",
            hide: false,
          },
          {
            width: 150,
            overHidden: true,
            label: "创建人",
            prop: "create_user",
          },
          {
            overHidden: true,
            label: "创建时间",
            prop: "create_time",
            hide: false,
          },
        ],
      },
      model: "wisdom_park.wp_publish_material",
      data: [],
      selectionList: [],
      ruleModel: {},
    };
  },

  props: {
    isSelected: {
      type: String,
      default() {
        return "";
      },
    },
  },
  watch: {
    isSelected: {
      immediate: true,
      handler(val) {
        console.log(val);
        if (val == "selected") {
          this.option.menu = false;
          this.option.selection = true;
          this.option = JSON.parse(JSON.stringify(this.option));
        } else {
          this.option.menu = true;
          this.option.selection = false;
          this.option = JSON.parse(JSON.stringify(this.option));
        }
      },
    },
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.code_add, false),
        viewBtn: this.vaildData(this.permission.code_view, false),
        delBtn: this.vaildData(this.permission.code_delete, false),
        editBtn: this.vaildData(this.permission.code_edit, false),
      };
    },
  },
  mounted() {},
  methods: {
    selectionChange(list) {
      this.selectionList = list;
      this.$emit("selection", this.selectionList);
    },
    rowDel(row, index) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let pk = "id";
          delMetaCommon(this.model, { pk: pk, ids: [row[pk]] }).then((res) => {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.onLoad(this.page);
          });
        })
        .catch(() => {});
    },
    goDetail(type, row) {
      if (row) {
        this.$router.push({
          path: "/information/materialForm",
          query: { equipment: row.id, type: type },
        });
      } else {
        this.$router.push({
          path: "/information/materialForm",
        });
      }
    },
    refreshChange() {
      this.onLoad(this.page);
    },
    onLoad() {
      this.loading = true;
      let body = {
        current: this.page.current,
        size: this.page.size,
      };
      if (this.searchText) {
        body["wheres"] = [
          { field: "name", op: "LIKE", value: this.searchText },
        ];
      }
      getMetaCommonList(this.model, body).then((res) => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;

        this.loading = false;
        // this.selectionClear();
      });
    },
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.deleteIcon {
  font-size: 18px;
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1;
}
/deep/ .el-dialog__header {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 15px;
}
/deep/ .el-drawer__header {
  border-bottom: 1px solid #ebebeb;
  padding: 10px 20px;
  margin-bottom: 0px;
}
/deep/ .el-drawer__body {
  padding: 0px;
}
.buildDetail /deep/ .el-dialog__body {
  padding: 0px;
}
</style>
